import React from 'react';
import { useViewMode } from '../../utils/viewMode';
import { trackEvent } from '../../utils/analytics';
import '../../styles/components/EdgeTab.css';

/**
 * Persistent edge-of-screen affordance shown on the home page after
 * the splash chooser has been committed. Sticks to the opposite edge
 * from the current view (right edge while viewing Designer, left edge
 * while viewing Developer) and labels itself with the other view.
 * Clicking it flips the view via the same useViewMode hook the navbar
 * toggle uses, so the underlying state stays in sync everywhere.
 *
 * Visual style matches the side it points back to (light for
 * Designer, GitHub-dark for Developer) so the metaphor is "this is
 * what's behind that edge."
 */
const EdgeTab = () => {
    const [mode, setMode] = useViewMode();
    const opposite = mode === 'designer' ? 'developer' : 'designer';
    // Edge it sits on = the side the dismissed view was pushed to.
    // Click designer → dev slid right → tab on right edge → labeled Developer.
    // Click developer → designer slid left → tab on left edge → labeled Designer.
    const edge = mode === 'designer' ? 'right' : 'left';

    const handleClick = () => {
        setMode(opposite);
        trackEvent('edge_tab_clicked', { from: mode, to: opposite });
    };

    return (
        <button
            type="button"
            className={`EdgeTab EdgeTab--${edge} EdgeTab--target-${opposite}`}
            onClick={handleClick}
            aria-label={`Switch to ${opposite} portfolio`}
        >
            {edge === 'left' && <span className="EdgeTab__arrow" aria-hidden="true">←</span>}
            <span className="EdgeTab__label">{opposite === 'designer' ? 'Designer' : 'Developer'}</span>
            {edge === 'right' && <span className="EdgeTab__arrow" aria-hidden="true">→</span>}
        </button>
    );
};

export default EdgeTab;
